import { render, staticRenderFns } from "./StockTransferView.vue?vue&type=template&id=309f4c04"
import script from "./StockTransferView.vue?vue&type=script&lang=js"
export * from "./StockTransferView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports